module.exports = __webpack_public_path__ + "static/media/benefit_three.3dd74fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/benefits/benefit_three.png
// module id = 1444
// module chunks = 0